import { Table as BaseTable } from 'antd'
import camelCase from 'lodash/camelCase'
import noop from 'lodash/noop'
import snakeCase from 'lodash/snakeCase'
import React, { useMemo } from 'react'

import { SORT_ORDER } from 'constants/sort'
import { DEFAULT_PAGE_SIZE } from 'constants/table'
import { withActions } from 'utils/table'

export function Table({
  settings = { pageSize: DEFAULT_PAGE_SIZE, page: 1, filters: null, sort: null },
  columns,
  onAction = noop,
  onSelect = noop,
  onSettingsChange = noop,
  ...rest
}: any) {
  const renderWithAction = useMemo(() => withActions(onAction, onSelect), [onAction, onSelect])
  const columnWithActions = useMemo(() => {
    const sort = settings.sort ? settings.sort.split(':').map(camelCase) : null
    return columns.map((column: any) => {
      // eslint-disable-next-line no-param-reassign
      column.filteredValue = settings.filters?.[column.key]
      if (sort?.[0] === column.key) {
        // eslint-disable-next-line no-param-reassign
        column.sortOrder = sort[1] === SORT_ORDER.ASC ? SORT_ORDER.ASCEND : SORT_ORDER.DESCEND
      } else {
        // eslint-disable-next-line no-param-reassign
        column.sortOrder = false
      }
      return renderWithAction(column)
    })
  }, [columns, settings.filters, settings.sort, renderWithAction])

  function onSort({ field, order }: any) {
    if (!order) {
      onSettingsChange({
        ...settings,
        sort: undefined,
      })
    } else {
      const direction = order === SORT_ORDER.DESCEND ? SORT_ORDER.DESC : SORT_ORDER.ASC
      onSettingsChange({
        ...settings,
        sort: `${snakeCase(field)}:${direction}`,
      })
    }
  }

  function onPaginate({ current, pageSize }: any) {
    onSettingsChange({ ...settings, page: current, pageSize })
  }

  function onFilter(filters: any) {
    onSettingsChange({ ...settings, filters })
  }

  function onChange(pagination: any, filters: any, sorter: any, { action }: any) {
    switch (action) {
      case 'sort':
        onSort(sorter)
        break
      case 'paginate':
        onPaginate(pagination)
        break
      case 'filter':
        onFilter(filters)
        break
      default:
    }
  }

  return <BaseTable onChange={onChange} {...rest} columns={columnWithActions} />
}
